import { PropsWithChildren } from 'react'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'
import { pages } from '@app/util/links'
import { useClient } from '@based/sdk'
import {
  DropdownMenu,
  type DropdownMenuItem,
} from '@app/components/core/dropdown/DropdownMenu'

export const ProfileMenu = ({ children }: PropsWithChildren) => {
  const [language, _] = useLanguage()
  const navTranslations = i18n.languages[language].app.nav
  const dashboardTranslations = i18n.languages[language].app.dashboard.nav
  const client = useClient()

  const logOut = () => {
    void client.call('account-logout')
  }

  const items: DropdownMenuItem[] = [
    {
      label: dashboardTranslations.profile,
      linkProps: {
        to: pages.dashboardProfile,
        textStyle: { fontWeight: 400 },
      },
    },
    {
      label: dashboardTranslations.preferences,
      linkProps: {
        to: pages.dashboardPreferences,
        textStyle: { fontWeight: 400 },
      },
    },
    {
      label: dashboardTranslations.following,
      linkProps: {
        to: pages.dashboardFollowing,
        textStyle: { fontWeight: 400 },
      },
    },
    {
      label: navTranslations.dashboardHome,
      linkProps: {
        to: pages.dashboard,
        textStyle: { fontWeight: 400 },
      },
    },
    {
      label: navTranslations.logOut,
      linkProps: {
        onClick: logOut,
        textStyle: {
          textWrap: 'nowrap',
        },
      },
    },
  ]

  return (
    <DropdownMenu items={items} showOnHoverDesktop>
      {children}
    </DropdownMenu>
  )
}
